export const GET_DATA_TOURNAMENTS                       = "GET_DATA_TOURNAMENTS"
export const GET_DATA_POSITIONS_TOURNAMENT              = "GET_DATA_POSITIONS_TOURNAMENT"
export const GET_DATA_POSITIONS_PREDICTION_TOURNAMENT   = "GET_DATA_POSITIONS_PREDICTION_TOURNAMENT"